import { html, LitElement } from "lit";
import { customElement, property } from 'lit/decorators.js';
import style from './footer-panel.scss';

/**
 * Single column of footer.
 *
 * @slot - Slot for items in this column. Use `footer-row` in this slot.
 */

@customElement('footer-panel')
export class FooterPanel extends LitElement {
    static override styles = style;

    /**
     * Header of this panel. You can use `\n` in value of this attribute to force line break.
     */
    @property({
        converter: {
            fromAttribute: (value, _) => value?.replace('\\n', '\n'),
            toAttribute: (value: string, _) => value.replace('\\n', '\n'),
        }
    })
    header = '';

    override render() {
        return html`
            <p class="bold">${this.header}</p>
            <slot></slot>
        `;
    }

}


declare global {
    interface HTMLElementTagNameMap {
        'footer-panel': FooterPanel
    }
}
